import { render, staticRenderFns } from "./winery.vue?vue&type=template&id=60fee867&scoped=true"
import script from "./winery.vue?vue&type=script&lang=js"
export * from "./winery.vue?vue&type=script&lang=js"
import style0 from "./winery.vue?vue&type=style&index=0&id=60fee867&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fee867",
  null
  
)

export default component.exports